export default __webpack_public_path__ + "static/media/11en.c3c3b085.mp3";